export const environment = {
  production: false,
  version: '0.0.5-dev',
  sessionCryptoKey: 'Xqgx5xPF2+jAiJ/xLFzlccMAOKo3FYPlJS5kTuZsuRo=',
  productBackendEndpoint: 'https://api-easypay-dev.softdirex.com/v1',
  //bffEndpoint: 'https://api-sstock-dev.softdirex.com',
  bffEndpoint: 'https://localhost:3001',
  bffProductId: 4,
  sessionIdleMinutes: 5,
  sessionIdleWarningSeconds: 60,
  downloadUrl: 'https://play.google.com/store/apps/details?id=com.softdirex.easypay',
  whatsappNumber: '56939056553',
};
